import { Grid } from "@material-ui/core";
import { GridComponent, Inject } from "@syncfusion/ej2-react-grids";
import TablePaper from "../TablePaper";
import { useTranslation } from "react-i18next";
import { DataGridDefaultProps } from "./DataGridDefaultProps";
import { useState, useEffect } from "react";
import { Fields } from "@syncfusion/ej2-react-dropdowns";

export const DefaultDatagrid = (props) => {
    const { t } = useTranslation();
    const [columns, setColumns] = useState([])
    const [grid, setGrid] = useState(null);

    let toolbarItems
    let dataGridProps = new DataGridDefaultProps()
    let groupOptions = dataGridProps.getGroupOptions(props.groupOptions)
    let filterSettings = dataGridProps.getFilterSettings(props.filterSettings)
    let services = dataGridProps.getServices(props.services)

    if (props.handleExport) {
        let aditionalitems = [{
            id: 'ExportFile',
            text: t('ExportFile'),
        }]
        toolbarItems = dataGridProps.getToolBarCustom(aditionalitems)
    } else if (props.Export) {
        toolbarItems = dataGridProps.getToolBarItemsExport()
    }
    else {
        toolbarItems = dataGridProps.getToolBarItems()
    }

    useEffect(() => {
        if (props.columns.length) {
            setColumns(props.columns);
        }
        else {
            setColumns([]);
        }
    }, [props.columns]);

    const handlePdfQueryCellInfo = (args) => {
        let flag = true;
        let count = 0;
        const width = props.pdfWidth;
        const pdfcol = args.cell.gridRow.pdfGrid.columns;
        const gridCol = grid.getVisibleColumns();
        if (flag) {
            gridCol.filter((args) => {
                pdfcol.getColumn(count).width = width[count];
                count++;
                if (count === width.length) {
                    flag = false;
                }
            });
            flag = false;
        }
    };

    const handleToolbarClick = event => {
        const { item: { id: item } } = event;
        switch (item) {
            case 'grid_pdfexport':
                exportComplete()
                grid.pdfExport()
                break
            case 'grid_excelexport':
                exportComplete()
                grid.excelExport()
                break
            case 'workflow':
                props.onWorkflowClick()
                break
            case 'ExportFile':
                props.handleExport();
                break
            default:
                break
        }
    }

    const handleDataBound = () => {
        if (props.autofit) {
            grid.autoFitColumns();
        }
    };

    const exportComplete = () => {
        grid.columns.forEach((column) => {
            if (column.hideOnExport) {
                column.visible = true;
            }
        })
        if (props.hideHeaderOnExport) {
            var processGridExportObject = grid.excelExportModule.__proto__.processGridExport;
            grid.excelExportModule.__proto__.processGridExport = function (gobj, props, r) {
                var rows = processGridExportObject.call(this, gobj, props, r);
                rows.shift();
                rows.forEach((item, index) => {
                    item.index = index + 1;
                });
                return rows;
            };
        }

        if (props.customExport) { props.customExport() }
    }

    const getField = args => {
        return grid.getColumns()[args.cellIndex.cellIndex].field;
    }

    return (
        <TablePaper>
            <Grid item xs={12}>
                <GridComponent
                    id="grid"
                    ref={g => setGrid(g)}
                    recordClick={props.recordClick}
                    selectionSettings={props.selectionMode === 'checkbox' ? { checkboxMode: 'Default' } : dataGridProps.getSelectionSettings()}
                    excelExportComplete={exportComplete}
                    pdfExportComplete={exportComplete}
                    dataBound={handleDataBound}
                    groupSettings={groupOptions}
                    filterSettings={filterSettings}
                    dataSource={props.dataSource}
                    columns={columns}
                    cellSelected={args => props.cellSelected ? props.cellSelected(args, getField(args)) : null}
                    rowSelected={props.rowSelected}
                    rowDeselected={props.rowDeselected}
                    toolbar={toolbarItems}
                    toolbarClick={handleToolbarClick}
                    allowPaging={props.allowPaging}
                    allowReordering={true}
                    allowResizing={true}
                    allowPdfExport={false}
                    allowSelection={true}
                    pdfQueryCellInfo={props.pdfWidth ? handlePdfQueryCellInfo : null}
                    allowExcelExport={true}
                    showColumnMenu={true}
                    allowSorting={true}
                    allowFiltering={true}
                    allowGrouping={true}
                    autoFitColumns={true}
                    pageSettings={props.pageSettings ? props.pageSettings : null}
                >
                    <Inject services={services} />
                </GridComponent>
            </Grid>
        </TablePaper>
    );
};


//Exemplos :

//DataGrid com cellClick 
{/* 
    <DefaultDatagrid
    columns={columnsUserRegistrations(t)}
    dataSource={userRegistrationRows}
    cellSelected={(args, grid) =>
        selectedUserRegistrationChanged(args.data)
    } /> */}
